/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { FilterViewScope } from './FilterViewScope';
import {
    FilterViewScopeFromJSON,
    FilterViewScopeFromJSONTyped,
    FilterViewScopeToJSON,
    FilterViewScopeToJSONTyped,
} from './FilterViewScope';

/**
 * 
 * @export
 * @interface FilterView
 */
export interface FilterView {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    scope: FilterViewScope;
    /**
     * 
     */
    view_key: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    filters: { [key: string]: any; };
    /**
     * 
     */
    is_default: boolean;
    /**
     * 
     */
    date_created: Date;
    /**
     * 
     */
    date_modified?: Date;
}



/**
 * Check if a given object implements the FilterView interface.
 */
export function instanceOfFilterView(value: object): value is FilterView {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('scope' in value) || value['scope'] === undefined) return false;
    if (!('view_key' in value) || value['view_key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('filters' in value) || value['filters'] === undefined) return false;
    if (!('is_default' in value) || value['is_default'] === undefined) return false;
    if (!('date_created' in value) || value['date_created'] === undefined) return false;
    return true;
}

export function FilterViewFromJSON(json: any): FilterView {
    return FilterViewFromJSONTyped(json, false);
}

export function FilterViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterView {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'scope': FilterViewScopeFromJSON(json['scope']),
        'view_key': json['view_key'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'filters': json['filters'],
        'is_default': json['is_default'],
        'date_created': (json['date_created'] == null ? json['date_created'] : parseDateTime(json['date_created'])),
        'date_modified': json['date_modified'] == null ? undefined : (parseDateTime(json['date_modified'])),
    };
}

export function FilterViewToJSON(json: any): FilterView {
    return FilterViewToJSONTyped(json, false);
}

export function FilterViewToJSONTyped(value?: FilterView | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'scope': FilterViewScopeToJSON(value['scope']),
        'view_key': value['view_key'],
        'name': value['name'],
        'description': value['description'],
        'filters': value['filters'],
        'is_default': value['is_default'],
        'date_created': value['date_created'] == null ? value['date_created'] : serializeDateTime(value['date_created']),
        'date_modified': value['date_modified'] == null ? value['date_modified'] : serializeDateTime(value['date_modified']),
    };
}

